interface HtmlPreviewViewerProps {
  htmlContent: string;
  theme: any;
  onBack?: () => void;
  onDownload?: () => void;
  title?: string;
  subtitle?: string;
  showBackButton?: boolean;
  showDownloadButton?: boolean;
  downloadButtonLabel?: string;
  minHeight?: string;
}

/**
 * Reusable HTML Preview Viewer Component
 * Displays HTML content in an iframe using srcDoc for security
 * Used by both ReportsDirectory and Report Builder Preview
 */
export default function HtmlPreviewViewer({
  htmlContent,
  theme,
  onBack,
  onDownload,
  title = "Preview",
  subtitle,
  showBackButton = true,
  showDownloadButton = true,
  downloadButtonLabel = "Download PDF",
  minHeight = "100vh"
}: HtmlPreviewViewerProps) {
  return (
    <div style={{ 
      display: "flex", 
      flexDirection: "column", 
      height: "100%", 
      minHeight: minHeight,
      background: theme.background,
      color: theme.text
    }}>
      {/* Preview Header */}
      <div style={{ 
        padding: "12px 20px", 
        borderBottom: `1px solid ${theme.border}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        background: theme.cardBackground || theme.navbarBackground
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {showBackButton && onBack && (
            <button 
              onClick={onBack}
              style={{ 
                display: "flex",
                alignItems: "center",
                gap: 4,
                padding: "6px 12px", 
                borderRadius: 7, 
                fontSize: 13, 
                fontWeight: 600, 
                cursor: "pointer", 
                border: `1px solid ${theme.border}`,
                background: theme.background,
                color: theme.text
              }}
            >
              ← Back
            </button>
          )}
          <div>
            <div style={{ fontSize: 16, fontWeight: 600, color: theme.text }}>{title}</div>
            {subtitle && (
              <div style={{ fontSize: 13, color: theme.textSecondary }}>{subtitle}</div>
            )}
          </div>
        </div>
        {showDownloadButton && onDownload && (
          <button 
            onClick={onDownload}
            style={{ 
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "6px 14px", 
              borderRadius: 7, 
              fontSize: 13, 
              fontWeight: 600, 
              cursor: "pointer", 
              border: "none",
              background: theme.buttonBackground || theme.success || "#10b981",
              color: theme.buttonText || "white"
            }}
          >
            📥 {downloadButtonLabel}
          </button>
        )}
      </div>
      
      {/* HTML Content Display */}
      <div style={{ flex: 1, background: "#f5f5f5", overflow: "hidden" }}>
        <iframe
          srcDoc={htmlContent}
          style={{ 
            width: "100%", 
            height: "100%", 
            border: "none", 
            display: "block",
            minHeight: "1200px"
          }}
          title="HTML Report Preview"
        />
      </div>
    </div>
  );
}
